/**
 * should use string enum's but compodoc can't handle them, see https://github.com/compodoc/compodoc/issues/525
 * the `valueOf` sollution doesn't work with Angular Universal
 */
export const NotFoundRouteName = '404';
export const NotFound = 'NotFound';
export const ServerError = 'ServerError';
